import {useCallback, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, Icon} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {ComplianceHint} from 'types';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.SESSION_TEXT_CHAT.COMPLIANCE;

type Props = {
    hint: ComplianceHint;
};

export const AudioComplianceHint = ({hint}: Props) => {
    const {t} = useTranslation();
    const [detailsOpen, setDetailsOpen] = useState(false);
    const toggleDetails = useCallback(() => setDetailsOpen((value) => !value), []);
    const guidance = useMemo(() => hint.guidance || hint.reason, [hint.guidance, hint.reason]);
    const hasReasonDetails = useMemo(
        () => !!hint.guidance && !!hint.reason && hint.guidance.trim() !== hint.reason.trim(),
        [hint.guidance, hint.reason]
    );

    return (
        <div className='tw-flex tw-flex-col tw-gap-2 tw-text-base tw-text-dark tw-break-words'>
            <div className='tw-flex tw-items-center tw-gap-2 tw-text-warning tw-text-base'>
                <Icon name='alert-triangle' color='warning' size='sm' margin={false} />
                <span className='tw-font-bold'>{t(T_KEYS.TITLE)}</span>
            </div>
            {hint.rule && <div className='tw-font-semibold tw-text-dark tw-text-base'>{hint.rule}</div>}
            {guidance && <div>{guidance}</div>}
            {hasReasonDetails &&
                <Button
                    color='unstyled'
                    width='auto'
                    height='auto'
                    fontStyle='normal'
                    className='tw-self-start tw-mt-1 tw-text-default-dimmed !tw-border-0 !tw-p-0'
                    aria-expanded={detailsOpen}
                    Icon={<Icon name={detailsOpen ? 'chevron-down' : 'chevron-right'} size='sm' margin={false} />}
                    onClick={toggleDetails}
                >
                    {t(T_KEYS.WHY_FLAGGED)}
                </Button>}
            {hasReasonDetails && detailsOpen && <div className='-tw-mt-1 tw-text-dark'>{hint.reason}</div>}
        </div>
    );
};
